import type { FC } from 'react'

interface HeadingProps {
  heading: string
  align?: 'left' | 'center'
}

const Heading: FC<HeadingProps> = ({ heading, align = 'left' }) => {
  return (
    <h2
      className={`about-section__heading${align === 'center' ? ' about-section__heading--center' : ''}`}
    >
      {heading}
    </h2>
  )
}

export default Heading
